import { apiFetch } from './auth-service';

export type AchievementType =
  | 'mrr' | 'arr' | 'revenue' | 'funding' | 'investment' | 'grant' | 'valuation' | 'profit' | 'break_even'
  | 'customers' | 'users' | 'dau' | 'mau' | 'signups' | 'sales' | 'retention' | 'churn' | 'nps'
  | 'launch' | 'mvp' | 'beta' | 'feature' | 'app_store'
  | 'incorporation' | 'team_hire' | 'partnership' | 'contract' | 'pilot'
  | 'expansion' | 'ip_patent' | 'award' | 'media' | 'accelerator' | 'demo_day' | 'custom';

export interface AchievementDoc {
  _id: string;
  type: AchievementType;
  title: string;
  value?: number;
  unit?: string;
  description?: string;
  date: string;
  icon?: string;
}

export const listAchievements = async (): Promise<AchievementDoc[]> => {
  const r = await apiFetch.get<{ achievements: AchievementDoc[] }>('/startups/my/achievements');
  return r.achievements;
};

export const createAchievement = async (data: Omit<AchievementDoc, '_id'>): Promise<AchievementDoc> => {
  const r = await apiFetch.post<{ achievement: AchievementDoc }>('/startups/my/achievements', data);
  return r.achievement;
};

export const updateAchievement = async (id: string, data: Partial<AchievementDoc>): Promise<AchievementDoc> => {
  const r = await apiFetch.put<{ achievement: AchievementDoc }>(`/startups/my/achievements/${id}`, data);
  return r.achievement;
};

export const deleteAchievement = async (id: string): Promise<void> => {
  await apiFetch.delete(`/startups/my/achievements/${id}`);
};
